module.exports = __webpack_public_path__ + "static/img/14000063.ebe077f8.png";